import TitreZone from "../../../../../common/CarteLead/TitreZone";
import EmailLink from "../../../../../common/CommentList/common/EmailLink/EmailLink";
import PhoneLink from "../../../../../common/CommentList/common/PhoneLink/PhoneLink";
import { tarifDuDevis } from "../profilLead";

// Contact et demande d'un lead DOMI : téléphone, email, tarif du devis. Le
// titre ouvre « Infos et documents » dans le panneau.
const ZoneContactDomi = ({ lead, ouvrir }) => {
  const user = lead.user || {};
  const tarif = tarifDuDevis(lead);

  return (
    <section className="la-zone" aria-label="Contact et demande">
      <TitreZone icone="fa-id-card" onglet="infos" ouvrir={ouvrir}>
        Contact et demande
      </TitreZone>
      <ul className="la-coord">
        <li>
          <PhoneLink phone={user.phone} />
        </li>
        <li>
          <EmailLink email={user.email} />
        </li>
      </ul>
      <div className="la-prime">
        Tarif du devis : <b>{tarif ? `${tarif} €` : "non disponible"}</b>
      </div>
    </section>
  );
};

export default ZoneContactDomi;
